import { render } from "./AddEditAccounts.vue?vue&type=template&id=733da5f6&scoped=true"
import script from "./AddEditAccounts.vue?vue&type=script&lang=js"
export * from "./AddEditAccounts.vue?vue&type=script&lang=js"

import "./AddEditAccounts.vue?vue&type=style&index=0&id=733da5f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733da5f6"]])

export default __exports__